import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import * as Converter from "../converter";
import * as Schema from "../schema";

import type * as Type from "../type";

type Props = {
	hotelID: string;
};

type Result = {
	optionPmsOptionListQueryData: Type.QueryData.OptionPmsOptionListQueryData | undefined;
};

export const useOptionPmsOptionListQuery = ({ hotelID }: Props): Result => {
	const { data } = useCustomSuspenseQuery(Schema.OPTION_PMS_OPTION_LIST_FOR_OPTION_PMS, {
		variables: { hotelID },
	});

	const optionPmsOptionListQueryData = Converter.useOptionPmsOptionListConverter({
		optionPmsOptionListServerData: data,
	});

	return {
		optionPmsOptionListQueryData: optionPmsOptionListQueryData?.optionPmsOptionListQueryData,
	};
};
